import {registerMessageCommon, localizedMessage} from 'epic-react-common';
import LocalizationStore from '../../stores/LocalizationStore';

export {localizedMessage};

export default registerMessageCommon(LocalizationStore);
